import Image from '@/components/ui/Image';

export function SacramentalIcon() {
  return (
    <Image 
      src="/images/sacramental.svg" 
      alt="Título Sacramental" 
      width={32} 
      height={32} 
      className="drop-shadow-md"
    />
  );
}
